'use strict'

import TweenLite from 'gsap';

let self;

export default self = {
    container: document.querySelector('.floorplan-container'),
    filterBox: document.querySelector('.hometype-filter'),
    floorplans: [...document.querySelectorAll('.floorplan-container .floorplan')],

    init : () => {
      const floorplanFilters = self.floorplans.map( floorplanFilter => floorplanFilter.dataset.type )

      self.addFilters(floorplanFilters)
      self.filterItems.forEach( li => li.addEventListener('click', self.onFilterClick) )
    },

    onFilterClick : e => {
      const li = e.currentTarget
      const filterName = li.dataset.filter.trim();

      self.filterItems.forEach( list => list.classList.remove('active') )
      li.classList.add('active')
      self.findMatches(filterName, self.floorplans)
    },

    findMatches : (filterName, floorplans) => {
        floorplans.forEach((f)=>{
            const floorType = f.dataset.type.trim();
            f.style.display = 'block';

            if(filterName !== 'all'){
                if(floorType !== filterName){
                    f.style.display = 'none';
                }
            }
        });
    },

    addFilters : (floorplans) => {
        const uniqueFilters = Array.from(new Set(floorplans));
        let html = '<li data-filter="all"><span>All Homes</span></li>';
        html += uniqueFilters.map( filter => `<li data-filter="${filter}"><span>${filter}</span></li>` ).join('');

        self.filterBox.innerHTML = html;
        
        if (self.filterBox.hasAttribute('data-first')) {
	        self.filterBox.querySelector('li[data-filter="' + self.filterBox.getAttribute('data-first') + '"]').classList.add('active');
        }
        self.filterItems = [...document.querySelectorAll('.hometype-filter li')]
    }
}
